import mediaQueryBuilder from 'styles/helpers/mediaQueryBuilder';
import styled from '@emotion/styled';

const EyebrowText = styled('div')(({ theme }) => ({
  fontSize: '1.3rem',
  fontWeight: 'normal',
  letterSpacing: '2px',
  textTransform: 'uppercase',
  [mediaQueryBuilder(theme.mediaQueries.max.width['768'])]: {
    padding: '0 2.5rem 1.5rem',
  },
}));

export default EyebrowText;
